// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__22gYT","buttons":"Footer_buttons__cqFdw"};